module.exports = __webpack_public_path__ + "static/assets/514e6c5a07dde1ec563dea1c9f37f7a8.gif";